<template>
  <div id="drafts">
    <commonHeader :title="$t('home.db')" />
    <div class="common_btnBar">
      <el-button type="primary" @click="batchDelete">{{ $t('btn.BatchDel') }}</el-button>
    </div>
    <commonTable ref="draftsTable" @handleSelectChange="handleSelectChange" />
  </div>
</template>
<script>
import commonHeader from '@/components/commonHeader';
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import { drafts } from './service';

export default {
  name: 'Drafts',
  data () {
    return {
      tableData: [{}],
      selectRowCodes: []
    };
  },
  components: {
    commonHeader,
    commonTable
  },
  methods: {
    batchDelete () {
      let selectRowCode = this.$refs.draftsTable
        .getCheckboxRecords()
        .map(item => {
          return item.activityCode;
        });
      if (selectRowCode && selectRowCode.length <= 0) {
        this.$message({
          type: 'warning',
          message: this.$t('general.PsDi')
        });
        return;
      }
      this.$confirm(this.$t('general.Aystdtd'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      })
        .then(() => {
          drafts.draftDelete(selectRowCode).then(res => {
            if (res.status === '200') {
              this.loadTable();
              this.$message({
                type: 'success',
                message: this.$t('general.DeleSucc')
              });
            }
          });
        })
        .catch(() => {});
    },
    handleSelectChange (item) {},
    editBtn (row) {
      // 快捷申请
      if (row.submitType === 'quick_submit') {
        const path = row.reportType ? '/quickTransferApplication' : '/editQuickApplication';
        this.$router.push({
          path,
          query: {
            activityCode: row.activityCode,
            activeName: 'drafts',
            metaActive: '/drafts'
          }
        });
        return;
      }
      // 报备申请
      if (row.submitType === 'report_submit') {
        let path = '/reportApplication';
        if (row.reportType === 2) {
          path = '/industryReportApplication';
        } else if (row.reportType === 1) {
          path = '/regionReportApplication';
        }
        this.$router.push({
          path,
          query: {
            activityCode: row.activityCode,
            activeName: 'drafts',
            metaActive: '/drafts'
          }
        });
        return;
      }
      // 渠道申请
      if (row.submitType === 'qd_submit') {
        this.$router.push({
          path: '/editQdApplication',
          query: {
            activityCode: row.activityCode,
            activeName: 'drafts',
            metaActive: '/drafts'
          }
        });
        return;
      }
      if (row.submitType === 'normal_submit' && row.reportType) {
        this.$router.push({
          path: '/activityTransferApplication',
          query: {
            activityCode: row.activityCode,
            activeName: 'drafts',
            metaActive: '/drafts'
          }
        });
        return;
      }
      // 普通申请
      this.$router.push({
        path: '/editApplication',
        query: {
          activityCode: row.activityCode,
          activeName: 'drafts',
          metaActive: '/drafts'
        }
      });
    },
    deleteBtn (row) {
      this.$confirm(this.$t('general.Aystdtd'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      })
        .then(() => {
          drafts.draftDelete(row.activityCode).then(res => {
            if (res.status === '200') {
              this.$refs.draftsTable.removeRow(row);
              this.$message({
                type: 'success',
                message: this.$t('general.DeleSucc')
              });
            }
          });
        })
        .catch(() => {});
    },
    loadTable () {
      let tableRow = new TableRow();
      tableRow.push(new TableColumns()._width('6%')._others('checkbox'));
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('newApp.BasicInfo.an'))
          ._data('activityCode')
      );
      tableRow.push(
        new TableColumns()
          ._width('28%')
          ._title(this.$t('newApp.activityInfo.noa'))
          ._data('activityName')
      );
      tableRow.push(
        new TableColumns()
          ._width('16%')
          ._title(this.$t('newApp.activityInfo.toa'))
          ._data('activityType')
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('general.SaveTime'))
          ._data('modifyTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let date = new Date(
                row[column.property].replace(/-/g, '/')
              ).format('yyyy-MM-dd');
              return <span>{date}</span>;
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._width('10%')
          ._title(this.$t('eventList.Me'))
          ._data('totalCost')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('general.Operation'))
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button
                    type="text"
                    onClick={() => {
                      this.editBtn(row);
                    }}
                  >
                    {this.$t('btn.Edit')}
                  </el-button>
                  <el-button
                    type="text"
                    onClick={() => {
                      this.deleteBtn(row);
                    }}
                  >
                    {this.$t('btn.Delete')}
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.draftsTable.setColumn(column, {});
      this.$refs.draftsTable.loadTable({
        url: 'activity/drafts',
        listKey: 'marketActivityList',
        method: 'get'
      });
    }
  },
  mounted () {
    this.loadTable();
  }
};
</script>
<style lang="scss" scoped>
#drafts {
  width: 100%;
  > .group {
    > .el-button {
      margin-bottom: 10px;
    }
  }
}
</style>
